import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import {
  Select,
  InputLabel,
  MenuItem,
  FormHelperText,
  FormControl,
} from '@material-ui/core';

import useStyles from './commonStyles';

const BooleanField = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { label, name, value, onChange, disabled, helperText, ...rest } = props;

  return (
    <FormControl fullWidth>
      <InputLabel id={`select-${name}`} shrink={true} classes={{
        root: classes.textFieldLabel
      }}>{label}</InputLabel>
      <Select
        labelId={`select-${name}`}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        inputProps={{
          classes: {
            icon: classes.selectIcon,
            root: classes.select
          },
        }}
        {...rest}
      >
        <MenuItem value="1">{t('common:yes')}</MenuItem>
        <MenuItem value="0">{t('common:no')}</MenuItem>
      </Select>
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </FormControl>
  )
};

BooleanField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  options: PropTypes.array, // {label: 'foo', value: 'bar'}
  helperText: PropTypes.string
};

export default BooleanField;
